import axios from 'axios';
import {
  PLUGIN_LOAD_PLUGIN_FIELDS_BEGIN,
  PLUGIN_LOAD_PLUGIN_FIELDS_SUCCESS,
  PLUGIN_LOAD_PLUGIN_FIELDS_FAILURE,
  PLUGIN_LOAD_PLUGIN_FIELDS_DISMISS_ERROR,
} from './constants';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
export function loadPluginFields(args = {}) {
  return (dispatch) => {
    dispatch({
      type: PLUGIN_LOAD_PLUGIN_FIELDS_BEGIN,
    });
    const { projectId, version, uuid } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.get(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/extensions/${uuid}/loadFields/`,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: PLUGIN_LOAD_PLUGIN_FIELDS_SUCCESS,
            data: res.data,
          });
          resolve(res);
        },
        (err) => {
          dispatch({
            type: PLUGIN_LOAD_PLUGIN_FIELDS_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissLoadPluginFieldsError() {
  return {
    type: PLUGIN_LOAD_PLUGIN_FIELDS_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case PLUGIN_LOAD_PLUGIN_FIELDS_BEGIN:
      return {
        ...state,
        loadPluginFieldsPending: true,
        loadPluginFieldsError: null,
        pluginField: '',
      };

    case PLUGIN_LOAD_PLUGIN_FIELDS_SUCCESS:
      return {
        ...state,
        loadPluginFieldsPending: false,
        loadPluginFieldsError: null,
        pluginField: action.data,
      };

    case PLUGIN_LOAD_PLUGIN_FIELDS_FAILURE:
      return {
        ...state,
        loadPluginFieldsPending: false,
        loadPluginFieldsError: action.data.error,
      };

    case PLUGIN_LOAD_PLUGIN_FIELDS_DISMISS_ERROR:
      return {
        ...state,
        loadPluginFieldsError: null,
      };

    default:
      return state;
  }
}
